module.exports = __webpack_public_path__ + "static/media/group-picture-main.599d88e2.png";